/** 系统品牌文案（标题、侧栏等） */
export const APP_TITLE = '云盛OA系统';

/** 集团根组织展示名（组织树未加载时的兜底） */
export const GROUP_DISPLAY_NAME = '倍豪';
